import { render } from "./AutocompleteMultiple.vue?vue&type=template&id=237be2d6"
import script from "./AutocompleteMultiple.vue?vue&type=script&lang=js"
export * from "./AutocompleteMultiple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__